module.exports = __webpack_public_path__ + "static/media/studio1-3.8c3f6db3.png";